import { Navigate, useLocation } from 'react-router-dom'

import { useAuth } from '../../hooks/useAuth'
import Loading from '../loading/Loading'

import RequireData from './RequireData'


const RequireAuth = () => {
  const { isLoading, isAuthenticated } = useAuth()
  const location = useLocation()

  return (
    <div className="h-screen w-full">
      <Loading loading={isLoading} label="Nutzer wird geladen...">
        {isAuthenticated ? (
          <RequireData />
        ) : (
          <Navigate to="/login" state={{ from: location }} replace />
        )}
      </Loading>
    </div>
  )
}

export default RequireAuth
